// extracted by mini-css-extract-plugin
export default {"temperature_wrap":"TemperatureBoxSmall_temperature_wrap__R7ms3"};